<script setup>

    import axios from "axios";
    import { onBeforeMount } from "vue";
    import { useStore } from "vuex";
    import loadGif from "@/assets/img/loading.gif";
    import { toast } from 'vue3-toastify';
    import validSession from '../assets/js/valid-session';

    const store = useStore();

    onBeforeMount(() => {

        validSession.isLogged();

        store.state.validation = {
            urlHasError: false,
            urlMessageError: '',
            identifierHasError: false,
            identifierMessageError: '',
            secretHasError: false,
            secretMessageError: '',
        };

        store.state.whmcs = {
            id: '',
            url: '',
            identifier: '',
            secret: '',
            active: 'N'
        };

        store.state.sendingConfig = false;

        get_config();

    });

    const get_config = () => {

        axios.get('whmcs')
        .then(res => {
            
            if(res.data){

                store.state.whmcs = {
                    id: res.data.id,
                    url: res.data.url,
                    identifier: res.data.identifier,
                    secret: res.data.secret,
                    active: res.data.active
                };

            }

        })
        .catch(err => {
            console.error(err); 
        })

    }

    const save_config = async () => {

        let data = new FormData();

        store.state.validation.urlHasError = false;
        store.state.validation.identifierHasError = false;
        store.state.validation.secretHasError = false;

        data.append('identifier', store.state.whmcs.identifier);
        data.append('secret', store.state.whmcs.secret);
        data.append('url', store.state.whmcs.url);
        data.append('active', store.state.whmcs.active);

        let toast_message = 'Configuração salva com sucesso!';

        let url = 'whmcs';

        if(store.state.whmcs.id > 0){
            url = 'whmcs/update/'+store.state.whmcs.id;
        }

        await axios.post(url, data)
        .then(res => {
            
            if(res.data.error){

                let messages = res.data.messages;

                Object.entries(messages).forEach((value) => {

                    if(value[0] == 'identifier'){
                        store.state.validation.identifierHasError = true;
                        store.state.validation.identifierMessageError = value[1];
                    }
                    else if(value[0] == 'secret'){
                        store.state.validation.secretHasError = true;
                        store.state.validation.secretMessageError = value[1];
                    }
                    else if(value[0] == 'url'){
                        store.state.validation.urlHasError = true;
                        store.state.validation.urlMessageError = value[1];
                    }


                });

                if(res.data.error == 'Não foi possível salvar a configuração no momento tente mais tarde!'){

                    toast('Não foi possível salvar a configuração no momento tente mais tarde!', {
                        autoClose: 3000,
                        theme: "auto",
                        type: "error",
                        transition: "slide"
                    });

                }

                store.state.sendingConfig = false;

            }
            else{

                store.state.validation = {
                    urlHasError: false,
                    urlMessageError: '',
                    identifierHasError: false,
                    identifierMessageError: '',
                    secretHasError: false,
                    secretMessageError: '',
                }; 

                toast(toast_message, {
                    autoClose: 3000,
                    theme: "auto",
                    type: "success",
                    transition: "slide"
                });

                store.state.sendingMessage = false;


            }

        })
        .catch(err => {
            console.error(err); 
        })

    }

</script>

<template>
    <div class="py-4 container-fluid overflow-auto max-height-vh-90">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="row align-items-center mb-n2 mb-md-2 mt-md-n2">
                            <div class="col-6">
                                <h6 class="text-white">Configuração do WHMCS</h6>
                            </div>
                            <div class="col-6">
                                
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pt-0 pb-2">

                        <div class="row pe-4 ps-4">
                            <div class="col-12 mt-4">
                                <p>Com essa integração iremos sincronizar seus clientes de forma automática com nossos clientes, criar lançamentos vinculados aos clientes, baixa automática do lançamento.</p>
                                <p><b>Obs:</b> É necessário incluir o IP: 201.182.96.134 na sua restrição de IP em "Opções > Configurações Geral > Segurança > Restrição de acesso IP da API"</p>
                            </div>
                            <div class="col-6 mx-auto mt-3 mb-3">
                                <label for="whmcsActive">Ativo</label>
                                <select 
                                        class="form-select form-select-lg" 
                                        v-model="store.state.whmcs.active"
                                        id="whmcsActive"
                                    >
                                        <option value="Y">Sim</option>
                                        <option value="N">Não</option>
                                            
                                    </select>
                            </div>
                            <div class="col-6 mx-auto mt-3 mb-3">
                                <label for="whmcsUrl">URL</label>
                                <input 
                                    type="text" 
                                    class="form-control form-control-lg" 
                                    id="whmcsUrl"
                                    name="whmcsUrl"
                                    v-model="store.state.whmcs.url"
                                    v-bind:class="{
                                        'is-invalid': store.state.validation.urlHasError,
                                        'darkmode': darkMode,
                                    }"
                                >
                                <div id="urlFeedback" class="invalid-feedback">
                                    {{ store.state.validation.urlMessageError }}
                                </div>
                            </div>
                            <div class="col-11 col-lg-6 mx-auto">
                                <div class="col-12 mb-3">
                                    <label for="whmcsIdentifier">Identificação</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="whmcsIdentifier"
                                        name="whmcsIdentifier"
                                        v-model="store.state.whmcs.identifier"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.identifierHasError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                    <div id="identifierFeedback" class="invalid-feedback">
                                        {{ store.state.validation.identifierMessageError }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-11 col-lg-6 mx-auto">
                                <div class="col-12 mb-3">
                                    <label for="whmcsSecret">API Secret</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="whmcsSecret"
                                        name="whmcsSecret"
                                        v-model="store.state.whmcs.secret"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.secretHasError,
                                            'darkmode': darkMode,
                                        }"
                                    >
                                    <div id="secretFeedback" class="invalid-feedback">
                                        {{ store.state.validation.secretMessageError }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-center mt-3 mb-3">
                                <button
                                    v-if="!store.state.sendingConfig"
                                    @click="save_config()"
                                    class="btn btn-success"
                                >
                                    Salvar
                                </button>
                                <img v-if="store.state.sendingConfig" :src="loadGif" alt="" width="50">
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>